export const mostrarValorDescuento = (descuento, tipo) => {
	if (tipo === 'PORCENTAJE') return (descuento * 100) + '%';
	else return descuento;
};

export const parsearValorDescuentoInput = (valor) => {
	if (typeof valor === 'number') {
		return Number.isFinite(valor) ? valor : NaN;
	}

	const valorNormalizado = String(valor ?? '')
		.trim()
		.replace(',', '.');

	if (valorNormalizado === '') {
		return NaN;
	}

	const valorParseado = Number(valorNormalizado);
	return Number.isFinite(valorParseado) ? valorParseado : NaN;
};

export const normalizarValorDescuentoParaApi = (valorInput, tipo) => {
	const valorParseado = parsearValorDescuentoInput(valorInput);
	if (!Number.isFinite(valorParseado)) {
		return NaN;
	}

	if (tipo === 'PORCENTAJE') {
		return valorParseado > 1 ? valorParseado / 100 : valorParseado;
	}

	return valorParseado;
};

export const normalizarValorDescuentoParaFormulario = (valorApi, tipo) => {
	const valorParseado = parsearValorDescuentoInput(valorApi);
	if (!Number.isFinite(valorParseado)) {
		return '';
	}

	if (tipo === 'PORCENTAJE') {
		return valorParseado <= 1 ? valorParseado * 100 : valorParseado;
	}

	return valorParseado;
};

export const esValorPorcentajeValido = (valorInput) => {
	const valorParseado = parsearValorDescuentoInput(valorInput);
	return Number.isFinite(valorParseado) && valorParseado > 0 && valorParseado <= 100;
};
